const assignTeamDropdownStyles = (theme) => ({
  menuItem: {
    padding: theme.spacing(1, 2),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  teamInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
  },
  teamLogo: {
    width: 32,
    height: 32,
  },
  loadingContainer: {
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
  },
  emptyState: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
})

export default assignTeamDropdownStyles
